module.exports = __webpack_public_path__ + "static/media/Logo_Collega.c5f399ba.svg";